export default __webpack_public_path__ + "static/media/circle-plus.84112313.svg";